// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * React Flow 레이아웃 수정을 위한 CSS
 * 이 파일은 react-flow__container와 react-flow__pane 간의 레이아웃 문제를 해결합니다.
 */

/* 기본 컨테이너 스타일 확인
   주의: React Flow v12 는 선택 박스(.react-flow__selection)와 다중선택 사각형(.react-flow__nodesselection)에도
   react-flow__container 클래스를 붙이고 인라인 width/height/transform 으로 크기를 잡는다.
   아래 !important 100% 규칙에 걸리면 선택 영역이 캔버스 전체로 커지므로 둘은 제외한다. */
.react-flow__container:not(.react-flow__selection):not(.react-flow__nodesselection), 
.xyflow__container:not(.xyflow__selection):not(.xyflow__nodesselection) {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 0;
}

/* 팬/드래그 영역이 전체 컨테이너를 차지하도록 */
.react-flow__pane, 
.xyflow__pane {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1;
}

/* 뷰포트 영역 확인 */
.react-flow__viewport, 
.xyflow__viewport {
  position: absolute !important;
  z-index: 2;
  transform-origin: 0 0 !important;
  /* transform 초기화 없음 - React Flow 내부 관리 */
}

/* viewport가 react-flow__container로 잘못 클래스화된 경우 수정 */
.react-flow__viewport.react-flow__container,
.xyflow__viewport.xyflow__container {
  position: absolute !important;
  /* container 역할도 하는 경우 width/height 100% 유지 */
  width: 100% !important; 
  height: 100% !important;
  /* transform은 유지 - 패닝/줌 표현에 필요 */
}

/* 노드 영역이 겹치지 않도록 */
.react-flow__nodes, 
.xyflow__nodes {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  pointer-events: none;
  z-index: 3;
}

/* 개별 노드는 포인터 이벤트 활성화 */
.react-flow__node, 
.xyflow__node {
  position: absolute !important;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: all;
  transform-origin: 0 0;
  z-index: 4;
}

/* 엣지 영역 */
.react-flow__edges, 
.xyflow__edges {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  pointer-events: none;
  z-index: 5;
}

/* 엣지 경로 및 마커 z-index 명시 */
.react-flow__edge-path,
.xyflow__edge-path,
.react-flow__edge-marker,
.xyflow__edge-marker,
.react-flow__edge-textwrapper,
.xyflow__edge-textwrapper {
  z-index: 10 !important;
}

/* 엣지 상호작용 영역에 pointer-events 활성화 */
.react-flow__edge-interaction,
.xyflow__edge-interaction {
  pointer-events: all !important;
  z-index: 15 !important;
}

/* 그룹 노드 z-index 설정 */
.react-flow__node-group,
.xyflow__node-group,
.react-flow__node-subflow,
.xyflow__node-subflow,
.react-flow__node-repeatGroup,
.xyflow__node-repeatGroup {
  z-index: 0 !important;
}

/* 일반 노드들은 그룹 노드보다 위에 표시 */
.react-flow__node:not([data-is-group="true"]),
.xyflow__node:not([data-is-group="true"]) {
  z-index: 0 !important;
}

/* 부모 노드가 있는 자식 노드 */
.react-flow__node[data-parent-id],
.xyflow__node[data-parent-id] {
  z-index: 0 !important;
}

/* 부모 드래그 중인 자식 노드 */
.react-flow__node[data-parent-dragging="true"],
.xyflow__node[data-parent-dragging="true"] {
  z-index: 4 !important;
}

/* 선택된 그룹 노드는 일반 노드보다는 낮고 비선택 그룹보다는 높게 */
.react-flow__node-group.selected,
.xyflow__node-group.selected,
.react-flow__node-subflow.selected,
.xyflow__node-subflow.selected,
.react-flow__node-repeatGroup.selected,
.xyflow__node-repeatGroup.selected {
  z-index: 5 !important;
}

/* 전체 React Flow 영역이 캔버스 영역을 채우도록 확장 */
.react-flow,
.xyflow {
  width: 100% !important;
  height: 100% !important;
  position: relative !important;
} 
/* 연결선(엣지를 그리는 중) — React Flow 기본값 z-index 1001 을 되살린다.
   위의 .react-flow__container 규칙(:not 3중 클래스)이 React Flow 의 .react-flow__connectionline 규칙보다
   우선순위가 높아 z-index 0 으로 눌리면서, 그리는 동안만 연결선이 노드 뒤로 숨었다. */
.react-flow__connectionline,
.xyflow__connectionline {
  z-index: 1001 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/workflow/canvas/ReactFlowFix.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;;4DAG4D;AAC5D;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,cAAc;AACd;;EAEE,6BAA6B;EAC7B,UAAU;EACV,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,oDAAoD;AACpD;;EAEE,6BAA6B;EAC7B,6CAA6C;EAC7C,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;;EAEE,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA,UAAU;AACV;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;;;;;;EAME,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;;;;;;EAME,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;;EAEE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;;EAEE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;;EAEE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;;;;;;EAME,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;;wDAEwD;AACxD;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* \r\n * React Flow 레이아웃 수정을 위한 CSS\r\n * 이 파일은 react-flow__container와 react-flow__pane 간의 레이아웃 문제를 해결합니다.\r\n */\r\n\r\n/* 기본 컨테이너 스타일 확인\r\n   주의: React Flow v12 는 선택 박스(.react-flow__selection)와 다중선택 사각형(.react-flow__nodesselection)에도\r\n   react-flow__container 클래스를 붙이고 인라인 width/height/transform 으로 크기를 잡는다.\r\n   아래 !important 100% 규칙에 걸리면 선택 영역이 캔버스 전체로 커지므로 둘은 제외한다. */\r\n.react-flow__container:not(.react-flow__selection):not(.react-flow__nodesselection), \r\n.xyflow__container:not(.xyflow__selection):not(.xyflow__nodesselection) {\r\n  position: absolute !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  top: 0 !important;\r\n  left: 0 !important;\r\n  right: 0 !important;\r\n  bottom: 0 !important;\r\n  z-index: 0;\r\n}\r\n\r\n/* 팬/드래그 영역이 전체 컨테이너를 차지하도록 */\r\n.react-flow__pane, \r\n.xyflow__pane {\r\n  position: absolute !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  top: 0 !important;\r\n  left: 0 !important;\r\n  right: 0 !important;\r\n  bottom: 0 !important;\r\n  z-index: 1;\r\n}\r\n\r\n/* 뷰포트 영역 확인 */\r\n.react-flow__viewport, \r\n.xyflow__viewport {\r\n  position: absolute !important;\r\n  z-index: 2;\r\n  transform-origin: 0 0 !important;\r\n  /* transform 초기화 없음 - React Flow 내부 관리 */\r\n}\r\n\r\n/* viewport가 react-flow__container로 잘못 클래스화된 경우 수정 */\r\n.react-flow__viewport.react-flow__container,\r\n.xyflow__viewport.xyflow__container {\r\n  position: absolute !important;\r\n  /* container 역할도 하는 경우 width/height 100% 유지 */\r\n  width: 100% !important; \r\n  height: 100% !important;\r\n  /* transform은 유지 - 패닝/줌 표현에 필요 */\r\n}\r\n\r\n/* 노드 영역이 겹치지 않도록 */\r\n.react-flow__nodes, \r\n.xyflow__nodes {\r\n  position: absolute !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  pointer-events: none;\r\n  z-index: 3;\r\n}\r\n\r\n/* 개별 노드는 포인터 이벤트 활성화 */\r\n.react-flow__node, \r\n.xyflow__node {\r\n  position: absolute !important;\r\n  user-select: none;\r\n  pointer-events: all;\r\n  transform-origin: 0 0;\r\n  z-index: 4;\r\n}\r\n\r\n/* 엣지 영역 */\r\n.react-flow__edges, \r\n.xyflow__edges {\r\n  position: absolute !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  pointer-events: none;\r\n  z-index: 5;\r\n}\r\n\r\n/* 엣지 경로 및 마커 z-index 명시 */\r\n.react-flow__edge-path,\r\n.xyflow__edge-path,\r\n.react-flow__edge-marker,\r\n.xyflow__edge-marker,\r\n.react-flow__edge-textwrapper,\r\n.xyflow__edge-textwrapper {\r\n  z-index: 10 !important;\r\n}\r\n\r\n/* 엣지 상호작용 영역에 pointer-events 활성화 */\r\n.react-flow__edge-interaction,\r\n.xyflow__edge-interaction {\r\n  pointer-events: all !important;\r\n  z-index: 15 !important;\r\n}\r\n\r\n/* 그룹 노드 z-index 설정 */\r\n.react-flow__node-group,\r\n.xyflow__node-group,\r\n.react-flow__node-subflow,\r\n.xyflow__node-subflow,\r\n.react-flow__node-repeatGroup,\r\n.xyflow__node-repeatGroup {\r\n  z-index: 0 !important;\r\n}\r\n\r\n/* 일반 노드들은 그룹 노드보다 위에 표시 */\r\n.react-flow__node:not([data-is-group=\"true\"]),\r\n.xyflow__node:not([data-is-group=\"true\"]) {\r\n  z-index: 0 !important;\r\n}\r\n\r\n/* 부모 노드가 있는 자식 노드 */\r\n.react-flow__node[data-parent-id],\r\n.xyflow__node[data-parent-id] {\r\n  z-index: 0 !important;\r\n}\r\n\r\n/* 부모 드래그 중인 자식 노드 */\r\n.react-flow__node[data-parent-dragging=\"true\"],\r\n.xyflow__node[data-parent-dragging=\"true\"] {\r\n  z-index: 4 !important;\r\n}\r\n\r\n/* 선택된 그룹 노드는 일반 노드보다는 낮고 비선택 그룹보다는 높게 */\r\n.react-flow__node-group.selected,\r\n.xyflow__node-group.selected,\r\n.react-flow__node-subflow.selected,\r\n.xyflow__node-subflow.selected,\r\n.react-flow__node-repeatGroup.selected,\r\n.xyflow__node-repeatGroup.selected {\r\n  z-index: 5 !important;\r\n}\r\n\r\n/* 전체 React Flow 영역이 캔버스 영역을 채우도록 확장 */\r\n.react-flow,\r\n.xyflow {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  position: relative !important;\r\n} \n/* 연결선(엣지를 그리는 중) — React Flow 기본값 z-index 1001 을 되살린다.\n   위의 .react-flow__container 규칙(:not 3중 클래스)이 React Flow 의 .react-flow__connectionline 규칙보다\n   우선순위가 높아 z-index 0 으로 눌리면서, 그리는 동안만 연결선이 노드 뒤로 숨었다. */\n.react-flow__connectionline,\n.xyflow__connectionline {\n  z-index: 1001 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
